import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

export function setLocale (locale) {
  window.localStorage.setItem('dc2023-locale', locale)
  i18n.locale = locale
}

export function getLocale () {
  const available = ['pl', 'en']

  const savedLocale = window.localStorage.getItem('dc2023-locale')
  if (savedLocale && available.includes(savedLocale)) return savedLocale

  const browserLocales =
    window.navigator.languages === undefined
      ? [window.navigator.language]
      : window.navigator.languages
  if (browserLocales[0]) {
    const browserLocale = browserLocales[0].split(/-|_/)[0]
    if (browserLocale && available.includes(browserLocale)) return browserLocale
  }

  return available[0]
}

function loadLocaleMessages () {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return messages
}

const i18n = new VueI18n({
  locale: getLocale(),
  fallbackLocale: 'pl',
  messages: loadLocaleMessages()
})

export default i18n
